
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...searchresults]]",
      function () {
        return require("private-next-pages/[[...searchresults]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...searchresults]]"])
      });
    }
  